"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var search_1 = __importDefault(require("material-ui/svg-icons/action/search"));
var Input_1 = __importDefault(require("./Input"));
var debounced_1 = __importDefault(require("./debounced"));
var IconButton_1 = __importDefault(require("./IconButton"));
var enhancer = recompose_1.compose(recompose_1.defaultProps({ onChange: lodash_1.noop, label: 'Hledej', inputProps: {} }), recompose_1.withState('valueOnEnter', 'setValueOnEnter', function (_a) {
    var value = _a.value;
    return value;
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (newProps) {
        var value = newProps.value;
        var _a = this.props, oldValue = _a.value, setValueOnEnter = _a.setValueOnEnter;
        if (value !== oldValue) {
            setValueOnEnter(value);
        }
    },
}), recompose_1.withHandlers({
    onChangeOnEnter: function (_a) {
        var setValueOnEnter = _a.setValueOnEnter;
        return function (value) {
            setValueOnEnter(value);
        };
    },
}), recompose_1.withHandlers({
    onKeyPress: function (_a) {
        var onChange = _a.onChange, valueOnEnter = _a.valueOnEnter, value = _a.value;
        return function (e) {
            if (e.key === 'Enter' && (value !== undefined || valueOnEnter !== undefined)) {
                onChange(valueOnEnter);
            }
        };
    },
    onSearchPress: function (_a) {
        var onChange = _a.onChange, valueOnEnter = _a.valueOnEnter;
        return function () {
            if (valueOnEnter !== undefined) {
                onChange(valueOnEnter);
            }
        };
    },
    clearValue: function (_a) {
        var onChange = _a.onChange, setValueOnEnter = _a.setValueOnEnter;
        return function () {
            setValueOnEnter('');
            onChange('');
        };
    },
}), debounced_1.default(undefined, undefined, 1250), recompose_1.withProps(function (_a) {
    var onChange = _a.onChange, onKeyPress = _a.onKeyPress, onChangeOnEnter = _a.onChangeOnEnter, value = _a.value, valueOnEnter = _a.valueOnEnter, changeValueOnEnter = _a.changeValueOnEnter;
    return ({
        onChange: changeValueOnEnter ? onChangeOnEnter : onChange,
        onKeyPress: changeValueOnEnter ? onKeyPress : undefined,
        value: changeValueOnEnter ? valueOnEnter : value,
    });
}));
var UniversalFilter = function (_a) {
    var value = _a.value, onChange = _a.onChange, onKeyPress = _a.onKeyPress, onSearchPress = _a.onSearchPress, inputProps = _a.inputProps, enableClear = _a.enableClear, clearValue = _a.clearValue, loading = _a.loading, props = __rest(_a, ["value", "onChange", "onKeyPress", "onSearchPress", "inputProps", "enableClear", "clearValue", "loading"]);
    return (react_1.default.createElement("div", { className: "universal-filter-wrapper", style: { width: '100%', display: 'flex' } },
        react_1.default.createElement("div", { className: "universal-filter", style: __assign({ position: 'relative', maxWidth: 'calc(100% - 20px)', width: '300px', bottom: '0.5rem' }, props.style) },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    alignItems: 'center',
                    flexGrow: 1,
                    maxWidth: '100%',
                    margin: 0,
                } },
                react_1.default.createElement("div", { style: { width: '100%' } },
                    react_1.default.createElement(Input_1.default, __assign({ style: { maxWidth: '100%' }, fullWidth: true, label: props.label, onChange: onChange, onKeyPress: onKeyPress, value: value, disabled: loading }, inputProps))),
                react_1.default.createElement(IconButton_1.default, { onClick: onSearchPress },
                    react_1.default.createElement(search_1.default, null))))));
};
exports.default = enhancer(UniversalFilter);
//# sourceMappingURL=UniversalFilter.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/UniversalFilter.js
// module id = 973
// module chunks = 0